export default __webpack_public_path__ + "static/media/Kollektiv35_StimmeX_Web-14.4f9e8079.jpg";